<template>
    <div class="container">
        <div class="top-header">
            <div class="header-left">
                <div class="menu-button" @click="showSidebar = true">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="3" width="18" height="1.5" rx="0.75" fill="currentColor"/>
                    <rect y="8.25" width="18" height="1.5" rx="0.75" fill="currentColor"/>
                    <rect y="13.5" width="18" height="1.5" rx="0.75" fill="currentColor"/>
                  </svg>
                </div>
                <div class="current-title">{{ currentHistoryTitle || 'mevsme' }}</div>
            </div>
            <div class="header-right">
                <div class="new-button" @click="onDel" title="새 대화">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1.5V14.5M1.5 8H14.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                  </svg>
                </div>
            </div>
            <input type="file" ref="fileInput" @change="onFileChange" style="display: none" accept=".json">
        </div>

        <!-- Sidebar Overlay -->
        <div v-if="showSidebar" class="sidebar-overlay" @click="showSidebar = false"></div>

        <!-- Sidebar -->
        <div class="sidebar" :class="{ 'sidebar-open': showSidebar }">
            <div class="sidebar-header">
                <h3>대화 목록</h3>
                <div class="close-button" @click="showSidebar = false">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                  </svg>
                </div>
            </div>
            <div class="sidebar-content">
                <div v-if="histories.length === 0" class="no-history">저장된 대화가 없습니다.</div>
                <div v-for="history in histories" :key="history.id" class="history-item" :class="{ 'active-history': currentHistoryId === history.id }" @click="loadHistory(history)">
                    <div class="history-info">
                        <div v-if="editingHistoryId === history.id" class="edit-container">
                            <input
                                v-model="editingTitle"
                                @keyup.enter="saveTitle(history)"
                                @blur="saveTitle(history)"
                                ref="editInput"
                                class="history-edit-input"
                                @click.stop
                            >
                        </div>
                        <span v-else class="history-item-title">{{ history.title }}</span>
                        <span class="history-date">{{ history.date }}</span>
                    </div>
                    <span class="history-edit" @click.stop="startEdit(history)">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5 1.5L11.5 3.5L4.5 10.5H2.5V8.5L9.5 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span class="history-del" @click.stop="deleteHistory(history.id)">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </span>
                </div>
            </div>
            <div class="sidebar-sync-section">
                <div v-if="!isLoggedIn" class="action-button login-btn" @click="handleSyncLogin">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3"/>
                  </svg>
                  <span>동기화 시작 (Google)</span>
                </div>
                <div v-else class="user-info-bar">
                  <div class="user-meta">
                    <span class="user-email">{{ syncUserEmail }}</span>
                    <span class="sync-status" :class="{ 'syncing': isSyncing }">
                        {{ isSyncing ? '동기화 중...' : '동기화됨' }}
                    </span>
                  </div>
                  <div class="logout-btn" @click="handleSyncLogout" title="로그아웃">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
                    </svg>
                  </div>
                </div>
            </div>

            <div class="sidebar-actions">
                <div class="action-button" @click="onBackup">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 1V10M7.5 10L4.5 7M7.5 10L10.5 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 12H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                  </svg>
                  <span>내보내기</span>
                </div>
                <div class="action-button" @click="onRestoreClick">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 14V5M7.5 5L4.5 8M7.5 5L10.5 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 3H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                  </svg>
                  <span>불러오기</span>
                </div>
                <div class="action-button" @click="onExportHtml">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 5L1 7.5L4 10M11 5L14 7.5L11 10M9 2L6 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>HTML</span>
                </div>
            </div>
        </div>

        <div>
            <div class="empty-top"></div>
            <div class="intro">
              <p>"질문하는 나와 대답하는 나<br>찬성하는 나와 반대하는 나"</p>
            </div>
            <div class="copyright">soocoolkim@gmail.com</div>
            <div v-for="(row, index) in rows" :key="index">
              <line-container v-show="row && row.trim().length > 0" :align="index % 2 === 0 ? 'left' : 'right'">
                <div class="balloon-wrapper" :class="index % 2 === 0 ? 'wrapper-left' : 'wrapper-right'">
                  <!-- <span class="speaker-label">{{ index % 2 === 0 ? 'A' : 'B' }}</span> -->
                  <div class="balloon" :class="index % 2 === 0 ? 'balloon-left' : 'balloon-right'" @click="handleBubbleClick($event, index)">{{ row }}</div>
                </div>
              </line-container>
            </div>
            <line-container v-show="newRowName.length == 0" :align="rows.length % 2 !== 0 ? 'left' : 'right'">
              <div class="balloon-wrapper" :class="rows.length % 2 !== 0 ? 'wrapper-left' : 'wrapper-right'">
                <!-- <span class="speaker-label">{{ rows.length % 2 !== 0 ? 'A' : 'B' }}</span> -->
                <div class="balloon" :class="rows.length % 2 !== 0 ? 'balloon-left' : 'balloon-right'">{{ dots }}</div>
              </div>
            </line-container>

            <!-- Bubble Context Menu -->
            <transition name="fade-in-scale">
              <div v-if="isBubbleMenuVisible" class="bubble-menu-overlay" @click="closeBubbleMenu" @contextmenu.prevent="closeBubbleMenu">
                <div class="bubble-menu" :style="{ top: calculateMenuY(bubbleMenuPos.y) + 'px', left: calculateMenuX(bubbleMenuPos.x) + 'px' }">
                  <div class="bubble-menu-item" @click.stop="editBubble">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 1.5L11.5 3.5L4.5 10.5H2.5V8.5L9.5 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
                    </svg>
                    <span>수정</span>
                  </div>
                  <div class="bubble-menu-divider"></div>
                  <div class="bubble-menu-item delete" @click.stop="deleteBubble">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 3.5H12M4.5 3.5V2.5C4.5 1.95 4.95 1.5 5.5 1.5H8.5C9.05 1.5 9.5 1.95 9.5 2.5V3.5M3.5 3.5V11.5C3.5 12.05 3.95 12.5 4.5 12.5H9.5C10.05 12.5 10.5 12.05 10.5 11.5V3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>삭제</span>
                  </div>
                </div>
              </div>
            </transition>

            <div class="empty"></div>
        </div>
        <div class="fixed-input">
            <input ref="chatInput" type="text" v-model="newRowName" @input="updateLastItem" @keypress.enter="addItem" placeholder="메시지를 입력하세요 (내용 있으면 같은 화자, 빈 칸에서 Enter 시 화자 전환)">
        </div>

        <!-- PWA Install Banner -->
        <transition name="fade-slide">
            <div v-if="showInstallBanner" class="pwa-install-banner">
                <div class="pwa-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="white"/>
                    </svg>
                </div>
                <div class="pwa-info">
                    <div class="pwa-title">MevsMe 앱 설치</div>
                    <div class="pwa-desc">더 편리하게 이용하시겠어요?</div>
                </div>
                <div class="pwa-actions">
                    <button class="pwa-install-btn" @click="installApp">설치</button>
                    <button class="pwa-close-btn" @click="showInstallBanner = false">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>
        </transition>

        <!-- PWA Update Banner -->
        <transition name="fade-slide">
            <div v-if="showUpdateBanner" class="pwa-install-banner update-banner">
                <div class="pwa-icon update-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.5-9.11 0-12.58s9.21-3.47 12.72 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.75 1.23-4.25-2.5V8h1.5z" fill="white"/>
                    </svg>
                </div>
                <div class="pwa-info">
                    <div class="pwa-title">새 버전이 있습니다</div>
                    <div class="pwa-desc">업데이트 하시겠습니까?</div>
                </div>
                <div class="pwa-actions">
                    <button class="pwa-install-btn update-btn" @click="refreshApp">업데이트</button>
                    <button class="pwa-close-btn" @click="showUpdateBanner = false">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import LineContainer from './components/LineContainer.vue';

export default {
  name: 'App',
  components: {
    LineContainer
  },
  data(){
    return {
      rows: [''],
      newRowName: '',
      lastText: '',
      dots: '.',
      histories: [],
      showSidebar: false,
      currentHistoryId: null,
      editingHistoryId: null,
      editingTitle: '',
      // Sync State
      store: null,
      isLoggedIn: false,
      syncUserEmail: '',
      isSyncing: false,
      isInitializing: true,
      // PWA Install State
      deferredPrompt: null,
      showInstallBanner: false,
      showUpdateBanner: false,
      // Bubble Menu State
      isBubbleMenuVisible: false,
      selectedBubbleIndex: null,
      bubbleMenuPos: { x: 0, y: 0 }
    }
  },
  async mounted(){
    // AppSync SDK 초기화
    this.store = new window.AppSyncStorage({
      appId: '72100895-b5cf-4f00-b294-52aec0a7170d',
      serverUrl: 'https://appsync-one.vercel.app',
      prefix: 'mevsme:',
      autoSync: true
    });

    // ── 이벤트 등록 ──────────────────────────────────────────────────
    this.store.addEventListener('login', (e) => {
      this.isLoggedIn = true;
      this.syncUserEmail = e.detail.email;
      this.loadAllData();
    });

    this.store.addEventListener('logout', () => {
      this.isLoggedIn = false;
      this.syncUserEmail = '';
    });

    this.store.addEventListener('synced', (e) => {
      this.isSyncing = false;
      if (e.detail.direction === 'pull') {
        const changedKeys = e.detail.changed || [];
        // 인덱스 변경 시 histories 갱신
        if (changedKeys.includes('index')) {
          this.histories = JSON.parse(this.store.getItem('index') || '[]');
        }
        // 현재 열린 대화가 변경된 경우 rows 갱신
        if (this.currentHistoryId && changedKeys.includes(`chat:${this.currentHistoryId}`)) {
          this.rows = JSON.parse(this.store.getItem(`chat:${this.currentHistoryId}`) || '[""]');
        }
        // 현재 선택 대화 ID 변경 시 (다른 기기에서 열었을 때)
        if (changedKeys.includes('current_id')) {
          this.currentHistoryId = JSON.parse(this.store.getItem('current_id') || 'null');
        }
      }
    });

    this.store.addEventListener('error', (e) => {
      this.isSyncing = false;
      console.error('Sync Error:', e.detail);
    });

    this.store.addEventListener('pushing', () => { this.isSyncing = true; });
    
    // SDK 초기 실행
    await this.store.init();
    this.isLoggedIn = this.store.isLoggedIn();
    if (this.isLoggedIn) {
      this.syncUserEmail = localStorage.getItem('_appsync_email');
    }

    // ── 데이터 관리 및 로드 ──
    const isFirstRun = !this.store.getItem('_initialized');
    
    if (isFirstRun) {
      await this.migrateLegacyData();
    } else {
      await this.loadAllData();
    }

    // ── Query Param 처리 ──────────────────────────────────────────────────
    var queryString = window.location.search;
    var searchParams = new URLSearchParams(queryString);
    var paramValue = searchParams.get('data');

    if (paramValue) {
      try {
        const rows = JSON.parse(paramValue)
        if(rows) this.rows = this.normalizeRows(rows);        
        this.currentHistoryId = null; 
      } catch (error) {
        alert('URL 데이터를 읽는 데 실패했습니다.')
      }
    }

    setInterval(() => {
      this.dots = this.dots + '.';
      if(this.dots == '....') this.dots = "."
    }, 300);

    this.scrollDown();
    this.isInitializing = false;

    // ── PWA Install Prompt ──────────────────────────────────────────────
    window.addEventListener('beforeinstallprompt', (e) => {
      // Chrome/Android 앱 설치 권유
      e.preventDefault();
      this.deferredPrompt = e;
      
      // 이미 설치되어 있는지 확인 (일부 브라우저)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      if (!isStandalone) {
        // 약간의 지연 후 표시
        setTimeout(() => {
          this.showInstallBanner = true;
        }, 2000);
      }
    });

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.showInstallBanner = false;
      console.log('PWA was installed');
    });

    // ── PWA Update Handler ──────────────────────────────────────────────
    document.addEventListener('swUpdated', () => {
      this.showUpdateBanner = true;
    });

    this.focusInput();
  },
  computed: {
    typing(){
      return "..."
    },
    currentHistoryTitle() {
      const history = this.histories.find(h => h.id === this.currentHistoryId);
      return history ? history.title : '';
    }
  },
  watch: {
    rows: {
      handler(newRows) {
        if (this.isInitializing) return;
        
        // 1. 현재 대화 내용 저장 (개별 키)
        if (this.currentHistoryId) {
          const chatKey = `chat:${this.currentHistoryId}`;
          this.store.setItem(chatKey, JSON.stringify(newRows));
          
          // 2. 인덱스(목록) 정보 중 날짜 업데이트
          const index = this.histories.findIndex(h => h.id === this.currentHistoryId);
          if (index !== -1) {
            this.histories[index].date = new Date().toLocaleString();
            this.store.setItem('index', JSON.stringify(this.histories));
          }
        }
      },
      deep: true
    },
    histories: {
      handler(newHistories) {
        if (this.isInitializing) return;
        this.store.setItem('index', JSON.stringify(newHistories));
      },
      deep: true
    }
  },
  methods: {
    async migrateLegacyData() {
      // 1. 기존 데이터 읽기
      const legacyHistoriesRaw = localStorage.getItem('mevsme_histories');
      const legacyRowsRaw = localStorage.getItem('mevsme_rows');
      const legacyCurrentId = localStorage.getItem('mevsme_current_id');

      if (legacyHistoriesRaw) {
        try {
          const legacyHistories = JSON.parse(legacyHistoriesRaw);
          const index = [];

          // 2. 대화 목록 분해하여 개별 키로 저장
          for (const item of legacyHistories) {
            index.push({
              id: item.id,
              title: item.title,
              date: item.date
            });
            // 본문은 개별 키로 분산
            this.store.setItem(`chat:${item.id}`, JSON.stringify(item.rows || ['']));
          }
          this.store.setItem('index', JSON.stringify(index));
          this.histories = index;
        } catch (e) {
          console.error('Migration failed', e);
        }
      }

      // 현재 행 및 ID 저장
      if (legacyRowsRaw) {
        const parsedRows = JSON.parse(legacyRowsRaw);
        this.rows = this.normalizeRows(parsedRows);
      }
      
      if (legacyCurrentId && legacyCurrentId !== 'null') {
        const parsedId = JSON.parse(legacyCurrentId);
        this.currentHistoryId = parsedId;
        this.store.setItem('current_id', JSON.stringify(parsedId));
        // 현재 열린 행을 해당 ID 키로도 중복저장 (안정성)
        const chatKey = `chat:${parsedId}`;
        if (!this.store.getItem(chatKey)) {
          this.store.setItem(chatKey, JSON.stringify(this.rows));
        }
      }

      this.store.setItem('_initialized', 'true');
      console.log('Legacy data migration completed.');
    },

    loadAllData() {
      // 인덱스 로드
      const indexRaw = this.store.getItem('index');
      this.histories = indexRaw ? JSON.parse(indexRaw) : [];

      // 현재 대화 ID 로드
      const currentIdRaw = this.store.getItem('current_id');
      this.currentHistoryId = currentIdRaw ? JSON.parse(currentIdRaw) : null;

      // 현재 대화 내용 로드
      if (this.currentHistoryId) {
        const chatKey = `chat:${this.currentHistoryId}`;
        const rowsRaw = this.store.getItem(chatKey);
        this.rows = rowsRaw ? JSON.parse(rowsRaw) : [''];
      }
    },

    async handleSyncLogin() {
      try {
        await this.store.login();
      } catch (err) {
        alert('로그인에 실패했습니다: ' + err.message);
      }
    },

    handleSyncLogout() {
      if (confirm('동기화를 중단하고 로그아웃하시겠습니까?')) {
        this.store.logout();
      }
    },
    normalizeRows(rows) {
      // Convert old object format {id, name} to string format
      if (!Array.isArray(rows)) return [''];
      return rows.map(row => {
        if (typeof row === 'string') return row;
        if (typeof row === 'object' && row !== null) {
          return row.name || row.text || '';
        }
        return '';
      });
    },
    onDel(){
      const hasContent = this.rows.some(row => typeof row === 'string' && row.trim().length > 0);
      
      if (hasContent) {
        if (!this.currentHistoryId) {
          // 아직 저장되지 않은 대화인 경우 제목 입력 받기
          const firstRow = this.rows.find(row => typeof row === 'string' && row.trim().length > 0) || '';
          const defaultTitle = firstRow.substring(0, 20).trim() || '새 대화 ' + new Date().toLocaleString();
          const title = prompt("현재 대화를 저장할 제목을 입력하세요.\n(취소 시 저장되지 않고 초기화됩니다)", defaultTitle);
          
          if (title !== null) {
            const newId = Date.now();
            const newHistory = {
              id: newId,
              title: title.trim() || defaultTitle,
              date: new Date().toLocaleString()
            };
            this.histories.unshift(newHistory);
            // 본문 저장
            this.store.setItem(`chat:${newId}`, JSON.stringify([...this.rows]));
          } else {
            return; // 취소 시 초기화 중단
          }
        }
      }

      // 상태 초기화 및 새 대화 시작
      this.rows = [''];
      this.newRowName = '';
      this.currentHistoryId = null;
      this.store.setItem('current_id', 'null');
      
      if (window.location.search.includes('data=')) {
        window.location.href = '/';
      } else {
        this.focusInput();
      }
    },
    async loadHistory(history) {
      if (this.currentHistoryId === history.id) {
        this.showSidebar = false;
        return;
      }
      
      // 현재 열려있는 임시 대화가 있다면 저장 유무 확인 (생략 가능)

      this.currentHistoryId = history.id;
      this.store.setItem('current_id', JSON.stringify(this.currentHistoryId));

      // 본문 로드
      const chatKey = `chat:${history.id}`;
      const savedRows = this.store.getItem(chatKey);
      this.rows = savedRows ? JSON.parse(savedRows) : [''];
      
      this.showSidebar = false;
      this.scrollDown();
      this.focusInput();
    },
    deleteHistory(id) {
      if (confirm('이 대화 기록을 삭제하시겠습니까?\n(서버에서도 영구히 삭제됩니다)')) {
        this.histories = this.histories.filter(h => h.id !== id);
        this.store.removeItem(`chat:${id}`);
        
        if (this.currentHistoryId === id) {
          this.currentHistoryId = null;
          this.rows = [''];
          this.store.setItem('current_id', 'null');
        }
      }
    },
    onSave(){
      const str = JSON.stringify(this.rows)
      var param = encodeURIComponent(str);

      var protocol = window.location.protocol; // 프로토콜 (예: "http:" 또는 "https:")
      var hostname = window.location.hostname; // 호스트명 (예: "www.example.com")
      var port = window.location.port; // 포트 (문자열, 예: "8080" 또는 "")
      var currentHostWithoutParams = protocol + "//" + hostname + (port ? ":" + port : "");
      const newUrlPath = `${currentHostWithoutParams}/?data=${param}`

      {
          var textArea = document.createElement("textarea");
          textArea.value = newUrlPath;
          textArea.style.position = "fixed";
          textArea.style.top = "-9999px";
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          
          alert(`내용이 클립보드로 복사되었습니다. 저장해서 사용하세요`)

          history.pushState(null, null, newUrlPath);
      }
    },
    onBackup() {
      const dataStr = JSON.stringify(this.rows);
      const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
      
      const exportFileDefaultName = 'mevsme_backup.json';

      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    },
    onExportHtml() {
      let htmlContent = `
<!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="UTF-8"> <!-- 한글 깨짐 방지 -->
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>대화 내보내기</title>
<style>
  body { font-family: sans-serif; padding: 20px; background-color: #fff; }
  .container { max-width: 480px; margin: 0 auto; padding-bottom: 50px; }
  .line-container { display: flex; margin-top: 10px; }
  .align-left { justify-content: flex-start; }
  .align-right { justify-content: flex-end; }
  .balloon {
    padding: 10px 20px;
    position: relative;
    display: inline-block;
    font-weight: bold;
    max-width: 70%;
    word-wrap: break-word;
    font-size: 14px;
    color: #555;
  }
  .balloon-left {
    background-color: #a2c2e0;
    border-radius: 20px 20px 20px 0;
    margin-right: 50px;
  }
  .balloon-right {
    background-color: #ffb7b2;
    border-radius: 20px 20px 0px 20px;
    margin-left: 50px;
  }
  .footer-link {
    text-align: center;
    margin-top: 40px;
    padding: 20px;
  }
  .footer-link a {
    color: #4a90e2;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
  }
  .footer-link a:hover {
    text-decoration: underline;
  }
</style>
</head>
<body>
<div class="container">
`;
      this.rows.forEach((row, index) => {
        if (!row) return; 
        const alignClass = index % 2 === 0 ? 'align-left' : 'align-right';
        const balloonClass = index % 2 === 0 ? 'balloon-left' : 'balloon-right';
        console.log(alignClass)
        console.log(balloonClass)
        htmlContent += `
  <div class="line-container ${alignClass}">
    <div class="balloon ${balloonClass}">
      ${row}
    </div>
  </div>`;
      });
      htmlContent += `
  <div class="footer-link">
    <a href="https://mevsme.pages.dev" target="_blank">mevsme.pages.dev</a>
  </div>
</div>
</body>
</html>`;

      const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'mevsme_chat.html';
      link.click();
      URL.revokeObjectURL(url);
    },
    onRestoreClick() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const contents = e.target.result;
          const rows = JSON.parse(contents);
          if (Array.isArray(rows)) {
            if (confirm('현재 내용을 덮어쓰고 복원하시겠습니까?')) {
              this.rows = rows;
              alert('복원되었습니다.');
            }
          } else {
            alert('올바르지 않은 파일 형식입니다.');
          }
        } catch (error) {
           alert('파일을 읽는 중 오류가 발생했습니다.');
           console.error(error);
        }
      };
      reader.readAsText(file);
      e.target.value = ''; // Reset input to allow selecting same file again
    },
    lastIndex(){
      return this.rows.length - 1;
    },
    scrollDown(){
      setTimeout(() => {
        window.scroll({
          top: document.body.scrollHeight,
          behavior: 'smooth' // 부드러운 스크롤 효과
        });            
      }, 1)
    },
    addItem: function() {
      const lastContent = this.rows[this.lastIndex()]?.trim();
      
      // 첫 메시지 입력 시 자동으로 히스토리 생성 (기능적 편의)
      if (!this.currentHistoryId && lastContent) {
        const newId = Date.now();
        const autoTitle = lastContent.substring(0, 20) || '새 대화 ' + new Date().toLocaleString();
        
        this.currentHistoryId = newId;
        this.histories.unshift({
          id: newId,
          title: autoTitle,
          date: new Date().toLocaleString()
        });
        this.store.setItem('current_id', JSON.stringify(newId));
      }

      if (this.newRowName.trim() === '') {
        // 내용이 없는 경우: 화자 전환
        this.rows.push('');
      } else {
        // 내용이 있는 경우: 현재 화자 유지하면서 새 말풍선 (중간에 빈 행 추가하여 순서 유지)
        this.newRowName = '';
        this.rows.push(''); // 상대방 차례 건너뛰기
        this.rows.push(''); // 현재 화자의 새 행
      }
      this.scrollDown();
    },
    updateLastItem(event) {
      this.newRowName = event.target.value;
      const lastIndex = this.lastIndex();
      if (lastIndex >= 0) {
        this.lastText = this.newRowName;
        this.rows[lastIndex] = this.newRowName;
      }
    },
    startEdit(history) {
      this.editingHistoryId = history.id;
      this.editingTitle = history.title;
      this.$nextTick(() => {
        if (this.$refs.editInput && this.$refs.editInput[0]) {
          this.$refs.editInput[0].focus();
        }
      });
    },
    saveTitle(history) {
      if (this.editingHistoryId === null) return;
      
      const newTitle = this.editingTitle.trim();
      if (newTitle && newTitle !== history.title) {
        history.title = newTitle;
        // histories watch가 index 키를 업데이트함
      }
      this.editingHistoryId = null;
    },
    async installApp() {
      if (!this.deferredPrompt) {
        // iOS 등 beforeinstallprompt가 지원되지 않는 경우
        alert('브라우저의 "홈 화면에 추가" 기능을 이용해 설치해주세요.');
        this.showInstallBanner = false;
        return;
      }
      
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      console.log(`User response to the install prompt: ${outcome}`);
      
      this.deferredPrompt = null;
      this.showInstallBanner = false;
    },
    refreshApp() {
      this.showUpdateBanner = false;
      window.location.reload();
    },
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.chatInput) {
          this.$refs.chatInput.focus();
        }
      });
    },
    handleBubbleClick(event, index) {
      this.selectedBubbleIndex = index;
      this.bubbleMenuPos = {
        x: event.clientX,
        y: event.clientY
      };
      this.isBubbleMenuVisible = true;
    },
    closeBubbleMenu() {
      this.isBubbleMenuVisible = false;
      this.selectedBubbleIndex = null;
    },
    calculateMenuX(x) {
      const menuWidth = 120;
      const margin = 16;
      if (x + menuWidth + margin > window.innerWidth) {
        return window.innerWidth - menuWidth - margin;
      }
      return x;
    },
    calculateMenuY(y) {
      const menuHeight = 100;
      const margin = 16;
      if (y + menuHeight + margin > window.innerHeight) {
        return y - menuHeight;
      }
      return y;
    },
    editBubble() {
      const index = this.selectedBubbleIndex;
      const currentText = this.rows[index];
      const newText = prompt('메시지 수정:', currentText);
      if (newText !== null) { // 빈 칸 수정 허용 (빈 칸이면 화자 전환 의미)
        this.rows[index] = newText.trim();
        // updates are tracked via rows watch
      }
      this.closeBubbleMenu();
    },
    deleteBubble() {
      if (confirm('이 메시지를 삭제하시겠습니까?')) {
        this.rows.splice(this.selectedBubbleIndex, 1);
        // if rows becomes empty, ensure there's at least one empty string
        if (this.rows.length === 0) {
          this.rows = [''];
        }
      }
      this.closeBubbleMenu();
    }
  }  
}
</script>

<style>
/* ── AppSync UI Styles ── */

/* ── Bubble Context Menu Styles ── */
.bubble-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: transparent;
}

.bubble-menu {
  position: fixed;
  width: 120px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border);
  padding: 6px;
  display: flex;
  flex-direction: column;
  animation: menuIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 2001;
}

.fade-in-scale-enter-active, .fade-in-scale-leave-active {
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.fade-in-scale-enter-from, .fade-in-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

@keyframes menuIn {
  from { opacity: 0; transform: scale(0.95) translateY(-10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.bubble-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.15s;
}

.bubble-menu-item:hover {
  background: var(--surface-2);
}

.bubble-menu-item.delete {
  color: var(--danger);
}

.bubble-menu-item.delete:hover {
  background: #fef2f2;
}

.bubble-menu-divider {
  height: 1px;
  background: var(--border);
  margin: 4px;
}
.sidebar-sync-section {
  padding: 8px 12px 14px;
  border-top: 1px solid var(--border);
}

.login-btn {
  background: var(--surface-2) !important;
  color: var(--primary-color) !important;
  border: 1px dashed var(--primary-color) !important;
  flex-direction: row !important;
  gap: 8px !important;
  padding: 10px !important;
}

.user-info-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: var(--surface-2);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
}

.user-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.user-email {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sync-status {
  font-size: 10px;
  color: #10b981;
}

.sync-status.syncing {
  color: #f59e0b;
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s;
}

.logout-btn:hover {
  background: #fee2e2;
  color: var(--danger);
}

.update-banner {
  background: #1A1D2E !important;
  border: 1px solid #333;
}

.update-icon {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%) !important;
}

.update-btn {
  background: #10b981 !important;
  color: white !important;
}

.update-btn:hover {
  background: #059669 !important;
}

/* ── PWA Install Banner Styles ── */
.pwa-install-banner {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 488px;
  background: #2D3142;
  color: white;
  padding: 12px 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 200;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.pwa-icon {
  width: 40px;
  height: 40px;
  background: var(--primary-gradient);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pwa-info {
  flex: 1;
  min-width: 0;
}

.pwa-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 2px;
}

.pwa-desc {
  font-size: 12px;
  color: #CBD5E0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pwa-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pwa-install-btn {
  background: white;
  color: #2D3142;
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

.pwa-install-btn:hover {
  background: #F7FAFC;
  transform: scale(1.05);
}

.pwa-close-btn {
  background: transparent;
  border: none;
  color: #A0AEC0;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pwa-close-btn:hover {
  color: white;
}

/* Animations */
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translate(-50%, 20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translate(-50%, 20px);
}

:root {
  --primary-color: #5b5fef;
  --primary-gradient: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
  --surface: #ffffff;
  --surface-2: #f8f9fc;
  --border: #e8eaf0;
  --text-primary: #1a1d2e;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --danger: #ef4444;
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --radius-lg: 16px;
  --radius-md: 12px;
}

body {
  background-color: var(--surface-2);
  color: var(--text-primary);
}

/* Global Scrollbar */
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}

.container {
  max-width: 520px;
  margin: 0 auto;
  min-height: 100vh;
  background: var(--surface);
  box-shadow: 0 0 0 1px var(--border);
  position: relative;
  padding-bottom: 90px;
}

/* ── Header ── */
.top-header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 520px;
  z-index: 100;
  height: 56px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.menu-button {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.menu-button:hover {
  background: var(--surface-2);
  color: var(--text-primary);
}

.current-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
}

.header-right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.new-button {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.new-button:hover {
  background: var(--surface-2);
  color: var(--primary-color);
}

/* ── Sidebar ── */
.sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 15, 30, 0.25);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  z-index: 1000;
}

.sidebar {
  position: fixed;
  top: 0;
  left: -300px;
  width: 300px;
  height: 100%;
  background: var(--surface);
  z-index: 1001;
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border);
}
.sidebar-open {
  transform: translateX(300px);
}

.sidebar-header {
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border);
}
.sidebar-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

.close-button {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: background 0.15s, color 0.15s;
}
.close-button:hover {
  background: var(--surface-2);
  color: var(--text-primary);
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.no-history {
  padding: 24px 12px;
  text-align: center;
  font-size: 13px;
  color: var(--text-muted);
}

.history-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 6px;
  border-radius: var(--radius-md);
  transition: background 0.15s;
  cursor: pointer;
}
.history-item:hover {
  background: var(--surface-2);
}
.active-history {
  background: #eef0fd !important;
}

.history-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.history-item-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}
.history-date {
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}
.history-del,
.history-edit {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-muted);
  transition: background 0.15s, color 0.15s;
}
.history-edit:hover {
  background: var(--surface-2);
  color: var(--text-primary);
}
.history-del:hover {
  background: #fef2f2;
  color: var(--danger);
}

.history-edit-input {
  flex: 1;
  font-size: 13.5px;
  font-weight: 500;
  padding: 4px 8px;
  border: 1px solid var(--primary-color);
  border-radius: 6px;
  outline: none;
  background: var(--surface);
  color: var(--text-primary);
  width: 100%;
}

/* Sidebar Actions */
.sidebar-actions {
  border-top: 1px solid var(--border);
  padding: 12px;
  display: flex;
  gap: 8px;
}

.action-button {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 12px 8px;
  border-radius: var(--radius-md);
  background: var(--surface-2);
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid var(--border);
}
.action-button:hover {
  background: #eef0fd;
  color: var(--primary-color);
  border-color: #c7caff;
}

/* ── Chat Area ── */
.empty-top {
  height: 56px;
}

.intro {
  margin: 20px 24px 8px;
  padding: 20px 24px;
  text-align: center;
  color: var(--text-muted);
  font-size: 13.5px;
  line-height: 1.65;
  background: var(--surface-2);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
}

.intro p {
  margin: 0;
  font-style: italic;
}

.copyright {
  text-align: center;
  font-size: 10.5px;
  color: #d1d5db;
  margin: 8px 0 20px;
}

/* Chat Messages */
.balloon-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 80%;
  animation: fadeIn 0.25s ease-out;
}

.wrapper-left {
  align-items: flex-start;
  margin-left: 16px;
}

.wrapper-right {
  align-items: flex-end;
  margin-right: 16px;
}

.speaker-label {
  font-size: 10.5px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 4px;
  letter-spacing: 0.04em;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.balloon {
  padding: 11px 16px;
  font-size: 14.5px;
  line-height: 1.55;
  word-wrap: break-word;
  box-shadow: var(--shadow-sm);
}

.balloon-left {
  background: #f3f4f8;
  color: var(--text-primary);
  border-radius: 4px 18px 18px 18px;
}

.balloon-right {
  background: var(--primary-gradient);
  color: #ffffff;
  border-radius: 18px 4px 18px 18px;
  box-shadow: 0 3px 10px rgba(91, 95, 239, 0.22);
}

/* ── Input Area ── */
.fixed-input {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 520px;
  padding: 14px 16px;
  background: var(--surface);
  border-top: 1px solid var(--border);
  display: flex;
  align-items: center;
}

.fixed-input input {
  pointer-events: auto;
  width: 100%;
  padding: 12px 20px;
  font-size: 14.5px;
  border: 1.5px solid var(--border);
  border-radius: 24px;
  outline: none;
  background: var(--surface-2);
  color: var(--text-primary);
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  font-family: inherit;
}

.fixed-input input::placeholder {
  color: var(--text-muted);
}

.fixed-input input:focus {
  border-color: var(--primary-color);
  background: var(--surface);
  box-shadow: 0 0 0 3px rgba(91, 95, 239, 0.12);
}

.empty {
  height: 16px;
}

/* ── Responsive Layout for Wide Screens ── */
@media (min-width: 900px) {
  body {
    padding-left: 300px;
  }

  .sidebar {
    left: 0 !important;
    transform: none !important;
    box-shadow: none !important;
    border-right: 1px solid var(--border);
  }

  .sidebar-overlay,
  .menu-button,
  .sidebar-header .close-button {
    display: none !important;
  }

  /* Center the content in the remaining space (viewport width - sidebar width) */
  .container {
    margin: 0 auto !important;
    max-width: 520px !important;
    left: 0 !important;
    transform: none !important;
    box-shadow: 1px 0 0 var(--border), -1px 0 0 var(--border);
  }

  .top-header,
  .fixed-input {
    left: calc(300px + (100% - 300px) / 2) !important;
    transform: translateX(-50%) !important;
    width: 100% !important;
    max-width: 520px !important;
  }
}

/* ── Utility ── */
.line-container {
  margin-bottom: 12px;
  display: flex !important;
  width: 100%;
}
</style>